<script setup lang="ts">
import type AntiRobot from '@/components/base/form/AntiRobot.vue';

const antiRobotRef = ref<InstanceType<typeof AntiRobot> | null>(null);

const antiRobotToken = computed<string>(
  () => antiRobotRef.value?.finalCaptchaTokenValue ?? '',
);

type Emits = {
  reactivate: [];
  close: [];
};

const emit = defineEmits<Emits>();

function closeDialog() {
  emit('close');
}

function onReactivateAccountButtonClick() {
  emit('reactivate');

  closeDialog();
}

function onCancelButtonClick() {
  closeDialog();
}
</script>

<template>
  <BaseModal
    v-bind="$attrs"
    @close="closeDialog()"
  >
    <div :class="$style.reactivateAccount">
      <BaseCommonLogo
        always-logo
        class="!mb-4 !h-8"
        custom-size
      />

      <p :class="$style.title">
        {{ $t('account.dialog.reactivate_account.title') }}
      </p>

      <section class="relative w-full mt-4">
        <BaseFormAntiRobot ref="antiRobotRef" />
      </section>

      <div class="px-5 my-4">
        <BaseFormButton
          :class="$style.button"
          :disabled="!antiRobotToken"
          @click="onReactivateAccountButtonClick"
        >
          {{ $t('account.dialog.reactivate_account.confirm') }}
        </BaseFormButton>

        <BaseFormButton
          button-style="outlined"
          :class="[$style.button, $style.cancelButton]"
          @click="onCancelButtonClick"
        >
          {{ $t('account.dialog.reactivate_account.cancel') }}
        </BaseFormButton>
      </div>
    </div>
  </BaseModal>
</template>

<style module lang="postcss">
.reactivateAccount {
  @apply text-center p-6;
}

.title {
  @apply font-bold uppercase text-primary mt-4;
}

.button {
  @apply w-full;

  & + & {
    @apply mt-2;
  }

  &.cancelButton {
    @apply text-texts;
  }
}
</style>
